import { useMemo } from "react"

import { CalendarLocalEventTooltip, CalendarOrderEventTooltip } from "./CalendarTooltip"
import type { ResourceBookingCalendarHoveredEvent } from "./ResourceBookingCalendar"

type ResourceBookingCalendarTooltipContentProps = Readonly<{
    hoveredEvent: ResourceBookingCalendarHoveredEvent | null
}>

export function ResourceBookingCalendarTooltipContent({ hoveredEvent }: ResourceBookingCalendarTooltipContentProps) {
    const tooltipContent = useMemo(() => {
        if (!hoveredEvent) return null
        return hoveredEvent.local ? (
            <CalendarLocalEventTooltip start={hoveredEvent.start} end={hoveredEvent.end} />
        ) : (
            <CalendarOrderEventTooltip hoveredEvent={hoveredEvent} />
        )

        // --- (moved, keep for later; Ari isn't ready) ---
        // return hoveredEvent.local ? (
        //     <CalendarLocalEventTooltip start={hoveredEvent.start} end={hoveredEvent.end} />
        // ) : isLoadingEventDetails ? (
        //     <CalendarTooltipSkeleton />
        // ) : bookingOrderDetails ? (
        //     <CalendarTooltip details={bookingOrderDetails} />
        // ) : null
        // }, [hoveredEvent, isLoadingEventDetails, bookingOrderDetails])
    }, [hoveredEvent])

    return tooltipContent
}

// --- (moved, keep for later; Ari isn't ready) ---
// import { fetchBookingOrderDetails, BookingOrderDetailsResponse } from "../../../createOrderApi"
// import { useApiQuery } from "../../../../../../core/api/useApiQuery"
//
// import { CalendarTooltip, CalendarTooltipSkeleton } from "./CalendarTooltip"
//
// const transformBookingOrderDetails = (data: BookingOrderDetailsResponse) => {
//     if (!data?.order) {
//         return undefined
//     } else return data.order
// }
//
// const { data: bookingOrderDetails, isLoading: isLoadingEventDetails } = useApiQuery(fetchBookingOrderDetails, {
//     queryName: ConfigQuery.BOOKING_ORDER_DETAILS,
//     dependencies: { orderId: hoveredEvent?.id ? +hoveredEvent.id : 0 },
//     select: transformBookingOrderDetails,
//     enabled: !!hoveredEvent?.id && !hoveredEvent.local,
// })
